import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  conversionHref,
  type ConversionLinkAction,
} from "./parse-conversion-links";

export const ConversionLinkButton = memo(function ConversionLinkButton({
  action,
}: {
  action: ConversionLinkAction;
}) {
  const routes = useRequiredContext(MerchantRoutesContext);
  const navigate = useNavigate();
  const href = conversionHref(action.url, routes.getConversionSubRoute);
  const handleClick = useCallback(() => navigate(href), [href, navigate]);

  return (
    <Flex justify="flex-start">
      <RedoButton
        hierarchy="secondary"
        onClick={handleClick}
        size="sm"
        text={action.label}
      />
    </Flex>
  );
});
